import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'
import { Wrapper, FCAUpdateBox } from '../../reusable'
import { ConfirmDetails, ContactDetails, Person } from '../../formParts'
import { fieldValidation, uploadDataToServer } from '../../../helpers'
import { UploadDocuments } from '../../formParts/upload'
import { Complete } from '../../formParts/complete'
import { useUpdateClaimData } from '../../../claimProvider'
import { SignatureSentinel } from '../../formParts/signatureSentinel'
import { Chevron } from '../../reusable/chevron'
import { ClaimBanner } from '../../bannerClaim'
import { AddressDetails } from '../../formParts/addressDetails'
const LEAD_ORIGIN = 'webform_SENTINEL_MAILREFERRAL'
const steps = [
    {
        text: 'About You',
        transitionPoint: 1,
        step: 1,
    },
    {
        text: 'Contact Details',
        transitionPoint: 2,
        step: 2,
    },
    {
        text: 'Confirm Details',
        transitionPoint: 3,
        step: 3,
    },
    {
        text: 'E-Sign Documents',
        transitionPoint: 3,
        step: 3,
    },
    {
        text: 'Complete Application',
        transitionPoint: 4,
        step: 4,
    },
]

function ClaimFormMailReferral() {
    const [claimObject, setClaimObject] = useState<any>({
        leadOrigin: LEAD_ORIGIN,
        leadSource: window.location.href,
    })
    const [groupsComplete, setGroupsComplete] = useState(0)
    const [activeGroup, setActiveGroup] = useState('address')
    const updateClaim = useUpdateClaimData()
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => e.preventDefault()

    useEffect(() => {
        // console.log('CLAIM OBJECT CHANGED...', claimObject)

        updateClaim(claimObject)
    }, [claimObject])

    // const saveFieldValue = (dataToSave: SaveValueInterface) => {
    const saveFieldValue = (dataToSave: any) => {
        // console.log('DATA TO SAVE: ', dataToSave)
        let tempClaimObject = claimObject
        if (tempClaimObject) {
            tempClaimObject[dataToSave.field] = dataToSave.value
        }
        setClaimObject(tempClaimObject)

        // console.log("CLAIM OBJECT: ", claimObject);
        const validated = fieldValidation(dataToSave)
        if (validated.success) {
            return validated
        } else {
            return validated
        }
    }

    const activeGroupAssignment = async (group: string) => {
        if (group == 'signature') {
            const claimDataUploadResult = await uploadDataToServer(claimObject)
            if (claimDataUploadResult.success) {
                setActiveGroup(group)
                updateClaim({ ...claimDataUploadResult?.responseData.claimData, leadOrigin: LEAD_ORIGIN })
                window.scrollTo(0, 0)
                setGroupsComplete(groupsComplete + 1)
            }
        } else {
            setActiveGroup(group)
            window.scrollTo(0, 0)
            setGroupsComplete(groupsComplete + 1)
        }
    }

    return (
        <div>
            <ClaimBanner />
            <FCAUpdateBox />
            <div className={`${styles.claimProgressor} ${responsiveStyles.claimProgressor} `}>
                <div className={`${styles.progressorSections} ${responsiveStyles.progressorSections} `}>
                    {steps.map((e, i) => {
                        const gold = '#c88f5f'
                        const grey = 'lightgrey'
                        let chev1Colour = groupsComplete >= e.transitionPoint ? gold : grey
                        let chev2Colour = grey

                        if (steps.length > e.step) {
                            const nextTransistionPoint = steps[e.step].transitionPoint
                            chev2Colour = groupsComplete >= nextTransistionPoint ? gold : grey
                        }

                        return (
                            <div
                                key={i}
                                className={`${styles.progressorSingleSection} ${
                                    responsiveStyles.progressorSingleSection
                                } ${responsiveStyles.numberContainer} ${
                                    groupsComplete >= e.transitionPoint ? styles.complete : ''
                                }`}
                            >
                                <p>
                                    <span>{i + 1}</span>
                                    {e.text}
                                </p>

                                {i < 3 && <Chevron chev1Colour={chev1Colour} chev2Colour={chev2Colour} />}
                            </div>
                        )
                    })}
                </div>
            </div>
            <Wrapper>
                <div className={`${styles.formContainer} ${responsiveStyles.formContainer}`}>
                    <form className={`${styles.form}`} onSubmit={(e) => handleSubmit(e)}>
                        <div className={styles.formFields}>
                            <AddressDetails
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <Person
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <ContactDetails
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <ConfirmDetails
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <SignatureSentinel
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <UploadDocuments
                                saveValueFunct={saveFieldValue}
                                isActive={activeGroup}
                                assignGroup={activeGroupAssignment}
                            />
                            <Complete
                                isActive={activeGroup}
                                saveValueFunct={saveFieldValue}
                                assignGroup={activeGroupAssignment}
                            />
                        </div>
                    </form>
                </div>
            </Wrapper>
        </div>
    )
}

export default ClaimFormMailReferral
